import { useHistory, useLocation } from "react-router-dom";
import { PERSONAL_DATA_DAC7 } from "src/constants/UrlConstants";
import { useQueryParams } from "src/hooks/Utils/Url/useQueryParams";
import { ZARA_ADDRESS_URL_PARAMS } from "src/pages/ShoppingCart/models/CartShipping.model";
import { getUrlIds } from "src/hooks/Utils/useGridMainLogic";
import { useModal } from "src/hooks/Utils/useModal";
import { useOriginMonitor } from "src/hooks/Utils/useOriginMonitor";
import useSmartGoBack from "src/hooks/Utils/useSmartGoBack";
import { checkoutReset } from "src/model/services/checkout.service";
import { queryClient } from "src/utils/init/queryClient";;
import { onShowAFDLeaveAlertHandled } from "src/pages/AskForDetails/utils/AskForDetails.utils";
import { useSellNavigation } from "src/pages/NewSelll/utils/useSellNavigation";
import { useGridFilterStore } from "src/store/useGridFilters/useGridFilterStore";
import { useImageSearchStore } from "src/store/useImageSearch/useImageSearchStore";
import { useUploadProductStore } from "src/store/useUploadProduct/useUploadProductStore";
import { HELP_CATEGORIES, ROUTE_PATHS } from "src/utils/constants";
import { getEntryOrigin } from "src/utils/init/configuration";
import { handleOriginNavigation, navigateToZaraHome, } from "src/utils/navigation";
import { useNavigationHistory } from "src/utils/providers/NavigationHistoryProvider";
import useResponsive from "src/utils/useResponsive";
import { closeCommunication } from "src/utils/utils";
import { MatchedHandler } from "./Navigation.utils";
import { SessionConstants } from "src/utils/store-hooks/session-constants";
import { SessionService } from "src/utils/store-hooks/core/SessionService";
import { clearZaraRedirectState, isFromZaraRedirect } from "src/utils/ZaraRedirectUtils";

interface LocationState {
  isUserLoged?: boolean;
  fromAFD?: boolean;
}

export const useNavigationLogic = () => {
  const { WS } = useResponsive();
  const cartModal = useModal();
  const history = useHistory();
  const { hash, pathname } = useLocation();
  const location = useLocation<LocationState>();
  const sellNavigation = useSellNavigation();
  const { safeNavigateBack } = useNavigationHistory();
  const SET_SELL_FORM_EXIT_ALERT = useUploadProductStore((state) => state.SET_FORM_EXIT_ALERT,);
  const CLEAR_IMAGE_SEARCH = useImageSearchStore((state) => state.CLEAR_SEARCH);
  const CLEAR_IMAGE_FILE = useImageSearchStore((state) => state.CLEAR_FILE);
  useOriginMonitor();
  const smartGoBack = useSmartGoBack();
  const queryParams = useQueryParams();
  const personaldata = queryParams.get(PERSONAL_DATA_DAC7);
  const gridFilters = useGridFilterStore((state) => state.gridMainFilters);
  const SET_FILTER = useGridFilterStore((state) => state.SET_MAIN_FILTER);

  const setDefaultGridAndUniverse = () => {
    if (gridFilters.defaultGridUrl) {
      const gridAndUniverseIds = getUrlIds(gridFilters.defaultGridUrl);
      SET_FILTER("gridReferenceId", gridAndUniverseIds?.gridReferenceId, {
        gridReferenceId: gridAndUniverseIds?.gridReferenceId,
        parentGridId: null,
        universeId: gridAndUniverseIds?.universeId,
      });
      history.push(gridFilters.defaultGridUrl);
      window.scrollTo({
        top: 0,
        behavior: "auto",
      });
    } else {
      history.push(ROUTE_PATHS.PRODUCTS);
    }
  };

  const invalidateCustomerNotifications = () => {
    queryClient.invalidateQueries({ queryKey: ["customerNotification"] });
  };

  if (hash === "#cart" && cartModal?.isOpenModal === false) {
    cartModal.modalHandler();
  }



  const managerMatchedHandler = ( listHandlers: MatchedHandler[], alternativeAction?: () => void,) => {
    const matchedHandler = listHandlers?.find((handler) =>
      handler.match(pathname),
    );
    if (matchedHandler) {
      matchedHandler.action();
    } else if (alternativeAction) {
      alternativeAction();
    }
  };

  const checkForRedirectBack = ()=>{
  if (isFromZaraRedirect()) {
      if (pathname.includes(ROUTE_PATHS.COMMUNICATION)) {
        closeCommunication();
      } else {
        smartGoBack();
      }
    } else {
      smartGoBack();
    } 
  }
  const clearRedirectStateIfNeeded = () => {
    if (!pathname.includes(ROUTE_PATHS.PRODUCT_DETAIL)) {
      clearZaraRedirectState();
    }
  };

  const handleBackClick = () => {
    invalidateCustomerNotifications();
    clearRedirectStateIfNeeded();
    const routeHandlers = [
      {
        match: (path) => [ROUTE_PATHS.PAYMENT_CONFIRMATION, ROUTE_PATHS.CART].includes(path as any,),
        action: () => handleOriginNavigation(getEntryOrigin(), () => history.goBack(),pathname,),
      },
      {
        match: (path) => path.includes(ROUTE_PATHS.COMMUNICATION),
        action: () => history.push(ROUTE_PATHS.PRODUCTS),
      },
      {
        match: (path) => path.includes(ROUTE_PATHS.HELP) || path.includes(ROUTE_PATHS.REPORT) || path.includes(ROUTE_PATHS.OFFER_PRICE),
        action: () => smartGoBack(),
      },
      {
        match: (path) => path.includes(ROUTE_PATHS.REPORT_CONFIRMATION),
        action: () => history.push(ROUTE_PATHS.REPORT),
      },
      {
        match: (path) => path.includes(HELP_CATEGORIES.SELLING) || path.includes(HELP_CATEGORIES.BUYING),
        action: () => history.push(ROUTE_PATHS.HELP),
      },
      {
        match: (path) => path.includes(ROUTE_PATHS.PRODUCT_DETAIL) && !path.includes(ROUTE_PATHS.SELL),
        action: () => checkForRedirectBack(),
      },
      {
        match: (path) => path.includes(ROUTE_PATHS.SELLER_PROFILE) || path.includes(ROUTE_PATHS.BUNDLE),
        action: () => smartGoBack(),
      },
      {
        match: (path) => path.includes(ROUTE_PATHS.ASK_FOR_DETAILS),
        action: () => onShowAFDLeaveAlertHandled(),
      },
      {
        match: (path) => {
          if (!path.includes(ROUTE_PATHS.SELL)) return false;
          if ( path.includes(ROUTE_PATHS.SELL_FORM_EDIT) || path.includes(ROUTE_PATHS.SELL_FORM_NEW)) {
            SET_SELL_FORM_EXIT_ALERT(true);
            return true;
          }
          history.push(sellNavigation?.backRoute);
          return true;
        },
        action: () => {}, // La acción ya se realiza en el match
      },
      {
        match: (path) => path.includes(ROUTE_PATHS.PROFILE) && path.includes(ROUTE_PATHS.ADDRESS_LIST),
        action: () => history.push(`${ROUTE_PATHS.PROFILE}${ROUTE_PATHS.MY_ADDRESSES}${ROUTE_PATHS.SENDER_ADDRESS}`,),
      },
      {
        match: (path) => path.includes(ROUTE_PATHS.SEARCH_IMAGE_CROP),
        action: () => {
          CLEAR_IMAGE_SEARCH();
          CLEAR_IMAGE_FILE();
          history.push(ROUTE_PATHS.SEARCH);
        },
      },
      {
        match: (path) => path.includes(ROUTE_PATHS.SEARCH),
        action: () => history.push(ROUTE_PATHS.PRODUCTS),
      },
      {
        match: (path) => path.includes(ROUTE_PATHS.PROFILE) && path.includes(ROUTE_PATHS.MY_ADDRESSES) && path.includes(ROUTE_PATHS.SENDER_ADDRESS),
        action: () => history.push(`${ROUTE_PATHS.PROFILE}${ROUTE_PATHS.MY_ADDRESSES}`),
      },
      {
        match: (path) => path.includes(ROUTE_PATHS.PROFILE) && path.includes(ROUTE_PATHS.MY_ADDRESSES) && !path.includes(ROUTE_PATHS.SENDER_ADDRESS),
        action: () => history.push(ROUTE_PATHS.PROFILE),
      },
      {
        match: (path) => history?.location?.pathname?.includes(`${ROUTE_PATHS.MY_SALES}/`),
        action: () => history.push(ROUTE_PATHS.MY_SALES),
      },
      {
        match: (path) => history?.location?.pathname?.includes(`${ROUTE_PATHS.MY_PURCHASES}/`),
        action: () => history.push(ROUTE_PATHS.MY_PURCHASES),
      },
      {
        match: (path) => {
          return (
            path.includes(ROUTE_PATHS.MY_ITEMS) ||
            path.includes(ROUTE_PATHS.MY_SALES) ||
            path.includes(ROUTE_PATHS.MY_PURCHASES) ||
            path.includes(ROUTE_PATHS.MY_FAVORITES)
          );
        },
        action: () => history.push(ROUTE_PATHS.PROFILE),
      },
      {
        match: () => !!personaldata,
        action: () => history.push(ROUTE_PATHS.PROFILE),
      },
      {
        match: (path) => path.includes(ROUTE_PATHS.PROFILE),
        action: () => handleOriginNavigation( getEntryOrigin(), () => history.push(ROUTE_PATHS.PRODUCTS), pathname,),
      },
      {
        match: (path) => path.includes(ROUTE_PATHS.CHECKOUT_SHIPPING),
        action: () => history.push(ROUTE_PATHS.CART),
      },
      {
        match: (path) => path.includes(ROUTE_PATHS.STATEMENT_DAC7) || path.includes(ROUTE_PATHS.MY_PERSONAL_INFO),
        action: () => history.push(`${ROUTE_PATHS.PROFILE}?${PERSONAL_DATA_DAC7}=true`),
      },
      {
        match: () => location?.state?.fromAFD && !location?.state?.isUserLoged,
        action: () => history.push(ROUTE_PATHS.PRODUCTS),
      },
      {
        match: () => location?.state?.isUserLoged === undefined || location?.state?.isUserLoged === true,
        action: () => safeNavigateBack(),
      },
    ];

    managerMatchedHandler(routeHandlers, () => history.push(ROUTE_PATHS.PRODUCTS),);
  };

  const getWhiteBackGround = (): boolean => {
    return (
      pathname.includes(ROUTE_PATHS.MY_ITEMS) ||
      pathname.includes(ROUTE_PATHS.MY_SALES) ||
      pathname.includes(ROUTE_PATHS.MY_PURCHASES) ||
      pathname.includes(HELP_CATEGORIES.SELLING) ||
      pathname.includes(HELP_CATEGORIES.BUYING) ||
      pathname.includes(ROUTE_PATHS.ADDRESS_LIST) ||
      pathname.includes(ROUTE_PATHS.SELL)
    );
  };
  const whiteBackGround = getWhiteBackGround();

const handleDimissClick = () => {
  invalidateCustomerNotifications();
  clearRedirectStateIfNeeded();
  const dimissHandlers = [
    {
      match: (path) => path?.includes(ROUTE_PATHS.PAYMENT_CONFIRMATION),
      action: () => {
        checkoutReset();
        handleOriginNavigation(
          getEntryOrigin(),
          () => history.push(ROUTE_PATHS.PRODUCTS),
          pathname,
        );
      },
    },
    {
      match: (path) => path?.includes(ROUTE_PATHS.CART),
      action: () =>{
        handleOriginNavigation(getEntryOrigin(), () => smartGoBack(), pathname);
      },
    },
    {
      match: (path) => path?.includes(ROUTE_PATHS.SELL_SCAN_INTRO),
      action: () => history.push(ROUTE_PATHS.PRODUCTS),
    },
    {
      match: (path) => path.includes(ROUTE_PATHS.SELL_FORM_EDIT) || path.includes(ROUTE_PATHS.SELL_FORM_NEW),
      action: () => SET_SELL_FORM_EXIT_ALERT(true),
    },
    {
      match: (path) => path.includes(ROUTE_PATHS.OFFER_PRICE),
      action: () => smartGoBack(),
    },
    {
      match: () => true, // Default case
      action: () => navigateToZaraHome(),
    },
  ];

  managerMatchedHandler(dimissHandlers);
};

const onLogoClickHandled = () => {
  SessionService.remove(SessionConstants.SCROLL_STORAGE_KEY);

  clearZaraRedirectState();
  
  if (!WS) return setDefaultGridAndUniverse();

  invalidateCustomerNotifications();

  const logoClickHandlers = [
    {
      match: (path) => path?.includes(ROUTE_PATHS.PROFILE),
      action: () =>
        handleOriginNavigation(
          getEntryOrigin(),
          () => setDefaultGridAndUniverse(),
          pathname,
        ),
    },
    {
      match: (path) => path.includes(ROUTE_PATHS.SELL_FORM_EDIT) || path.includes(ROUTE_PATHS.SELL_FORM_NEW),
      action: () => SET_SELL_FORM_EXIT_ALERT(true),
    },
    {
      match: (path) => path?.includes(ROUTE_PATHS.PAYMENT_CONFIRMATION),
      action: () => {
        checkoutReset();
        history.push(ROUTE_PATHS.PRODUCTS); 
      },
    },
    {
      match: () => true, // Default case
      action: () => setDefaultGridAndUniverse(),
    },
  ];

  managerMatchedHandler(logoClickHandlers);
};

  return {
    handleBackClick,
    whiteBackGround,
    handleDimissClick,
    onLogoClickHandled,
  };
};
